import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import Page from "../../Common/Page";
import { useFetchSeason } from "~hooks/apiHooks/useFetchSeason.js";
import { Skeleton } from "antd";
import { useParams } from "react-router-dom";

const ManageSeasonWrapper = (props) => {
  const { children } = props;
  const params = useParams();
  const { data, isLoading, isPending } = useFetchSeason(params.seasonId, undefined, (seasonData) => {
    return { ...(seasonData?.data?.[0] || {}) }
  });
  const { formatMessage } = useIntl();
  const title = useMemo(() => `${formatMessage({ id: "season" })} - ${data?.nameLocal}`, [formatMessage, data]);

  if (isLoading || isPending) {
    return <Skeleton />;
  }

  return (
    <>
      <Page title={title} tabTitle={title}>
        {children}
      </Page>
    </>
  );
};

export default ManageSeasonWrapper;
